<button
  [disabled]="isSyncButtonDisabled(connectionStatusService.networkStatus$ | async)"
  mat-icon-button
  [matTooltip]="'TASKS.SYNC_TASK' | translate"
  (click)="synchronizeTask($event)">
  <mat-icon>sync</mat-icon>
</button>
<button
  [disabled]="!cellValue.isValid || !(connectionStatusService.networkStatus$ | async) || cellValue.type !== 'TOWER' || cellValue.status !== 'IN_PROGRESS'"
  mat-icon-button
  [matTooltip]="'TASKS.COPY' | translate"
  (click)="copyTask($event)">
  <mat-icon>content_copy</mat-icon>
</button>
<button
  *ngIf="store.isAdmin() && (connectionStatusService.networkStatus$ | async) && (cellValue.status === 'IN_PROGRESS' || cellValue.status === 'DRAFT') && (params.context['tasksListMode'] === 'ACTIVE')"
  mat-icon-button
  (click)="assignToUser($event)"
  [matTooltip]="'TASKS.SET_ASSIGNEE' | translate"
>
  <icon-outline icon="person_add_alt"></icon-outline>
</button>

